import { allCountries } from 'country-telephone-data';

const userType = [
    'SYSTEM',
    'HOSPITAL_STAFF',
    'TECHNICIAN'
  ];

  const userRoles = {
    SYSTEM : [ 'ROLE_DEFAULT'],
    TECHNICIAN: ['ROLE_FULL_USER'],
    HOSPITAL_STAFF: ['ROLE_REQUESTOR', 'ROLE_ADMINISTRATOR']
  }

  // Flat list of all available roles for direct selection in forms
  const allRoles = ['ROLE_DEFAULT', 'ROLE_FULL_USER', 'ROLE_REQUESTOR', 'ROLE_ADMINISTRATOR'];
  
  const permissions = {
    HOSPITAL_STAFF: [
      'ASSET_MANAGEMENT',
      'SERVICE_MANAGEMENT',
      'MAINTENANCE_MANAGEMENT',
      'HOSPITAL_USER_MANAGEMENT',
      'ADMINISTRATION_OPERATOR'
    ],
    TECHNICIAN: [
      'ADMINISTRATION_OPERATOR',
      'TECHNICIAN_SERVICE_MANAGEMENT',
      'TECHNICIAN_USER_MANAGEMENT'
    ]
  };

  const formatEnumName = (name) => {
  if (!name) return '';
  
  // Handle UPPER_SNAKE_CASE
  if (name === name.toUpperCase()) {
    return name.split('_')
      .map(word => word.charAt(0) + word.slice(1).toLowerCase())
      .join(' ');
  }
  
  // Handle camelCase
  return name
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, str => str.toUpperCase())
    .replace(/_/g, ' ');
};

   const formatCreatedDate = (dateStr) => {
    const date = new Date(dateStr);

    // Get user's locale from the browser
    const userLocale = navigator.language || 'en-IN'; // fallback to 'en-IN' (India)

    // Format the date according to the user's locale
    return date.toLocaleDateString(userLocale, {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

 const formatCamelCase = (key) =>
  key
    .replace(/([A-Z])/g, ' $1')     // insert space before uppercase letters
    .replace(/^./, (str) => str.toUpperCase()); // capitalize the first letter


const countryOptions = allCountries.map(country => ({
  value: country.iso2,
  label: (
    <div className="d-flex align-items-center">
      <img 
        src={`https://flagcdn.com/16x12/${country.iso2.toLowerCase()}.png`} 
        alt={country.name} 
        style={{ marginRight: '8px', width: '16px' }}
      />
      {`${country.name} (${country.dialCode})`}
    </div>
  ),
  labelText: `${country.name} (${country.dialCode})`,  // <-- add this
  dialCode: country.dialCode,
  name: country.name
}));

  const statusOptions = [
    "PENDING",
    "REJECTED",
    "APPROVED",
    "INPROGRESS"
  ];

// Format user type for display
const formatUserTypeName = (userType) => {
  if (!userType) return '';

  // Special case for HOSPITAL_STAFF (Organization Members)
  if (userType === 'HOSPITAL_STAFF') return 'Organization Members';

  // Convert to title case for other types
  return userType
    .toLowerCase()
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

    // utils.js
const formatRoleName = (role) => {
  if (!role) return '';

  // Remove ROLE_ prefix if present
  const cleanRole = role.replace(/^ROLE_/, '');

  // Special case for DEFAULT
  if (cleanRole === 'DEFAULT') return 'Default User';

  // Special case for ADMINISTRATOR (new consolidated admin role)
  if (cleanRole === 'ADMINISTRATOR') return 'Administrator';

  // Special case for FULL_USER (RBAC role) and BME (legacy)
  if (cleanRole === 'FULL_USER' || cleanRole === 'BME') return 'Full User';

  // Special case for REQUESTOR (Requester)
  if (cleanRole === 'REQUESTOR') return 'Requester';

  // Legacy roles - display as Administrator during transition
  if (['COO', 'BMD_HOD', 'HOD', 'HOSPITAL_ADMIN'].includes(cleanRole))
    return 'Administrator';

  // Convert to title case
  return cleanRole
    .toLowerCase()
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

 const currencies = {
    "USD": "USD - US Dollar",
    "EUR": "EUR - Euro",
    "GBP": "GBP - British Pound",
    "INR": "INR - Indian Rupee",
    "JPY": "JPY - Japanese Yen",
    "CAD": "CAD - Canadian Dollar",
    "AUD": "AUD - Australian Dollar",
    "CHF": "CHF - Swiss Franc",
    "CNY": "CNY - Chinese Yuan",
    "SGD": "SGD - Singapore Dollar",
    "HKD": "HKD - Hong Kong Dollar",
    "SEK": "SEK - Swedish Krona",
    "NOK": "NOK - Norwegian Krone",
    "DKK": "DKK - Danish Krone",
    "NZD": "NZD - New Zealand Dollar",
    "ZAR": "ZAR - South African Rand",
    "BRL": "BRL - Brazilian Real",
    "MXN": "MXN - Mexican Peso",
    "RUB": "RUB - Russian Ruble",
    "KRW": "KRW - South Korean Won",
    "TRY": "TRY - Turkish Lira",
    "PLN": "PLN - Polish Zloty",
    "CZK": "CZK - Czech Koruna",
    "HUF": "HUF - Hungarian Forint",
    "ILS": "ILS - Israeli Shekel",
    "AED": "AED - UAE Dirham",
    "SAR": "SAR - Saudi Riyal",
    "QAR": "QAR - Qatari Riyal",
    "KWD": "KWD - Kuwaiti Dinar",
    "BHD": "BHD - Bahraini Dinar",
    "OMR": "OMR - Omani Rial",
    "EGP": "EGP - Egyptian Pound",
    "MAD": "MAD - Moroccan Dirham",
    "NGN": "NGN - Nigerian Naira",
    "KES": "KES - Kenyan Shilling",
    "GHS": "GHS - Ghanaian Cedi",
    "THB": "THB - Thai Baht",
    "MYR": "MYR - Malaysian Ringgit",
    "IDR": "IDR - Indonesian Rupiah",
    "PHP": "PHP - Philippine Peso",
    "VND": "VND - Vietnamese Dong",
    "PKR": "PKR - Pakistani Rupee",
    "BDT": "BDT - Bangladeshi Taka",
    "LKR": "LKR - Sri Lankan Rupee",
    "NPR": "NPR - Nepalese Rupee",
    "AFN": "AFN - Afghan Afghani",
    "IRR": "IRR - Iranian Rial",
    "IQD": "IQD - Iraqi Dinar",
    "JOD": "JOD - Jordanian Dinar",
    "LBP": "LBP - Lebanese Pound",
    "SYP": "SYP - Syrian Pound",
    "ARS": "ARS - Argentine Peso",
    "CLP": "CLP - Chilean Peso",
    "COP": "COP - Colombian Peso",
    "PEN": "PEN - Peruvian Sol",
    "UYU": "UYU - Uruguayan Peso",
    "BOB": "BOB - Bolivian Boliviano",
    "PYG": "PYG - Paraguayan Guarani",
    "VES": "VES - Venezuelan Bolívar"
  };

const getStatusBadgeClass = (status) => {
  switch (status) {
    case "APPROVED":
      return "bg-success";
    case "REJECTED":
      return "bg-danger";
    case "PENDING":
      return "bg-warning text-dark";
    case "INPROGRESS":
      return "bg-primary";
    default:
      return "bg-secondary";
  }
};

const getStatusDescription = (status) => {
  switch (status) {
    case "APPROVED":
      return "User verification is complete and approved";
    case "REJECTED":
      return "User verification has been rejected";
    case "PENDING":
      return "Waiting for verification review";
    case "INPROGRESS":
      return "Verification is currently being processed";
    default:
      return "Status not specified";
  }
};

const urgencyColors = {
  HIGH: "bg-danger",
  MEDIUM: "bg-warning text-dark",
  LOW: "bg-success",
  SEVERE: "bg-dark",
  NONE: "bg-secondary",
  "": "bg-secondary", // nothing at all
  null: "bg-secondary",
  undefined: "bg-secondary",
};

const workstatusOptions = [
  {
    label: 'Open',
    icon: 'unlock',
    value: 'SUBMITTED',
    colorClass: 'bg-info text-white',
    borderColor: '#0dcaf0',
  },
  {
    label: 'In Progress',
    icon: 'refresh-ccw',
    value: 'IN_PROGRESS',
    colorClass: 'bg-warning text-dark',
    borderColor: '#ffc107',
  },
  {
    label: 'Resolved',
    icon: 'check-circle',
    value: 'RESOLVED',
    colorClass: 'bg-success text-white',
    borderColor: '#28a745',
  },
  {
    label: 'On Hold',
    icon: 'pause',
    value: 'ON_HOLD',
    colorClass: 'bg-danger text-white',
    borderColor: '#dc3545',
  },
 {
  label: 'Pending',
  icon: 'clock',
  value: 'PENDING',
  colorClass: 'bg-primary text-white',
  borderColor: '#0d6efd',
}

];

const assetStatusOptions = [
  { value: "IN_USE" },
  { value: "STANDBY" },
  { value: "PLANNED_DOWNTIME" },
  { value: "UNPLANNED_DOWNTIME" },
  { value: "AVAILABLE" },
  { value: "UNAVAILABLE" },
  { value: "DECOMMISSIONED" },
  { value: "DISPOSED" },
];

const groupedAssetStatusOptions = [
  {
    group: "Operational",
    options: [
      { value: "IN_USE", label: "In Use" },
      { value: "STANDBY", label: "Standby" },
    ]
  },
  {
    group: "Offline",
    options: [
      { value: "PLANNED_DOWNTIME", label: "Planned Downtime" },
      { value: "UNPLANNED_DOWNTIME", label: "Unplanned Downtime" },
    ]
  },
  {
    group: "Stored",
    options: [
      { value: "AVAILABLE", label: "Available" },
      { value: "UNAVAILABLE", label: "Unavailable" },
    ]
  },
  {
    group: "Retired",
    options: [
      { value: "DECOMMISSIONED", label: "Decommissioned" },
      { value: "DISPOSED", label: "Disposed" },
    ]
  }
];

/**
 * Handles API responses that may have warnings but still return 200 status
 * @param {Object} response - The API response object
 * @param {Function} onSuccess - Callback for successful operations
 * @param {Function} onWarning - Callback for operations with warnings (optional)
 * @param {Function} onError - Callback for error handling (optional)
 * @returns {Object} - Processed response with success flag and messages
 */
const handleApiResponse = (response, onSuccess = null, onWarning = null, onError = null) => {
  const { status, message, warning, error, response: data } = response;
  
  // Handle successful response (status 200)
  if (status === 200) {
    // Check for warnings
    if (warning && warning.length > 0) {
      const warningMessage = Array.isArray(warning) ? warning.join(', ') : warning;
      
      if (onWarning) {
        onWarning(warningMessage, data);
      }
      
      return {
        success: true,
        hasWarnings: true,
        message: message || 'Operation completed with warnings',
        warnings: warning,
        data: data
      };
    }
    
    // No warnings, fully successful
    if (onSuccess) {
      onSuccess(data);
    }
    
    return {
      success: true,
      hasWarnings: false,
      message: message || 'Operation completed successfully',
      data: data
    };
  }
  
  // Handle error responses
  const errorMessage = error || message || 'Operation failed';
  
  if (onError) {
    onError(errorMessage);
  }
  
  return {
    success: false,
    hasWarnings: false,
    message: errorMessage,
    error: error
  };
};

/**
 * Creates a notification message based on API response
 * @param {Object} apiResult - Result from handleApiResponse
 * @param {string} successMessage - Custom success message (optional)
 * @param {string} warningPrefix - Prefix for warning messages (optional)
 * @returns {Object} - Notification object with type and message
 */
const createNotificationFromApiResponse = (apiResult, successMessage = null, warningPrefix = '') => {
  if (!apiResult.success) {
    return {
      type: 'error',
      message: apiResult.message
    };
  }
  
  if (apiResult.hasWarnings) {
    const warningMessage = warningPrefix 
      ? `${warningPrefix}: ${apiResult.warnings.join(', ')}` 
      : `Warning: ${apiResult.warnings.join(', ')}`;
      
    return {
      type: 'warning',
      message: warningMessage
    };
  }
  
  return {
    type: 'success',
    message: successMessage || apiResult.message
  };
};

  export {
    userType,
    permissions,
    formatCreatedDate,
    formatEnumName,
    formatRoleName,
    formatUserTypeName,
    formatCamelCase,
    countryOptions,
    userRoles,
    allRoles,
    statusOptions,
    getStatusBadgeClass,
    getStatusDescription,
    workstatusOptions,
    urgencyColors,
    assetStatusOptions,
    groupedAssetStatusOptions,
    currencies,
    handleApiResponse,
    createNotificationFromApiResponse
  };
  